import { useEffect } from "react";

const API = process.env.REACT_APP_BACKEND_URL || "";

/** /scan — QR landing from physical marketing. Counts the scan
 *  (keepalive so the redirect doesn't cancel it) then forwards.
 *  Supports ?to=app to land on /app and ?src= for source tagging. */
export default function ScanRedirect() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const to = params.get("to") === "app" ? "/app" : "/";
    const src = params.get("src") || (to === "/app" ? "card" : "banner");
    try {
      if (!sessionStorage.getItem("eviq.scan_counted")) {
        sessionStorage.setItem("eviq.scan_counted", "1");
        fetch(`${API}/api/scan/track?source=${encodeURIComponent(src)}`, {
          method: "POST", keepalive: true,
        }).catch(() => {});
      }
      localStorage.setItem("eviq.device_seen", "1");
    } catch { /* noop */ }
    const t = setTimeout(() => window.location.replace(to), 250);
    return () => clearTimeout(t);
  }, []);
  return null;
}
